import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { RouteLoadingScreen } from './route-loading-screen';
import { InvalidRoutePage } from './pages/invalid-route-page';
import { RouteErrorBoundary } from './route-error-boundary';
import {
  appRoutes,
  authRoutes,
  moneyRoutes,
  posRoutes,
  purchasesRoutes,
  reportsRoutes,
  salesCustomerRoutes,
  teamRoutes,
  websiteRoutes,
} from './routes';

export function AppRouter() {
  return (
    <RouteErrorBoundary>
      <Suspense fallback={<RouteLoadingScreen />}>
        <Routes>
          {websiteRoutes()}
          {authRoutes()}
          {salesCustomerRoutes()}
          {purchasesRoutes()}
          {moneyRoutes()}
          {reportsRoutes()}
          {teamRoutes()}
          {posRoutes()}
          {appRoutes()}
          <Route path="*" element={<InvalidRoutePage />} />
        </Routes>
      </Suspense>
    </RouteErrorBoundary>
  );
}
